import React, { Fragment } from 'react';
import './styles.scss';
import Table from './../../../components/table/index';
import Button from '../../../components/button';
import AdminUserDelete from './../../user/admin-user/admin-user-delete/index';
import { connect } from 'react-redux';
import queryString from 'query-string';
import {toast} from 'react-toastify';
import {
    getAllCompanyAdmin, ACTIONS, addCompany, updateCompany,
    removeCompany, searchCompany,
    getAdminClient,
    addClientAdmin,
    deleteClientAdmin,
    updateClientAdmin,
    convertAdminClient,
    searchClient
} from './../../../actions/admin-company';
import Loading from '../../../components/loading';
import PopupNotification from '../../../components/popup-notification';

class AdminCompany extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isShowDropdown: false,
            isAdminClient: false,
            isShowOffAll: false,
            objAllCompanies: [],
            showLoading: false,
            name: '',
            code: '',
            message: '',
            showModalMessage: false,
            showModalAdd: false,
            showModalEdit: false,
            showModalDelete: false,
            allClientAdmin: [],
            emailClient: '',
            nameClient: '',
            passwordClient: '',
            isShowClient: false,
            showDeleteClient: false,
            showSettingClient: false,
            showPopup: false,
            idClient: '',
            email: '',
            nameClientSetting: '',
            passClientSetting: '',
            emailClientSetting: '',
            meta: null,
            formErrors: { passClientSetting: '', emailClient: '' },
            emailValid: false,
            passwordValid: false,
            codeValid: false,
            formValid: true,
            isReciveProps: false,
            // validate form add
            formErrors2: { passwordClient: '' },
            codeFormErrors: { codeClient: '' },
            passwordValid2: false,
            formValid2: false,
        }
    }

    validateCode(fieldName, value) {
        let codeValid = this.state.codeValid;
        let codeError = this.state.codeFormErrors;

        switch (fieldName) {

            case 'code':
                codeValid = value.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{2,}$/i);
                codeError.codeClient = codeValid ? '' : 'is invalid';
                break;
            default:
                break;
        }
        this.setState({
            codeValid: codeValid,
            codeFormErrors: codeError,

        }, this.validateCodeForm);
    }

    validateCodeForm() {
        this.setState({ formValid: this.state.codeValid  });
    }

    validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        let passwordValid = this.state.passwordValid;

        switch (fieldName) {

            case 'passClientSetting':
                passwordValid = value.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/i);
                fieldValidationErrors.passClientSetting = passwordValid ? '' : 'is invalid';
                break;
            default:
                break;
        }
        this.setState({
            formErrors: fieldValidationErrors,
            passwordValid: passwordValid,

        }, this.validateForm);
    }

    validateForm() {
        this.setState({ formValid: this.state.passwordValid  });
    }

    validateField2(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors2;
        let passwordValid2 = this.state.passwordValid2;
        let emailValid = this.state.emailValid;
        let isEmpty ;
        switch (fieldName) {
            case 'emailClient':
                isEmpty = !value ? false : true
                emailValid = value.match(/^([a-zA-Z_0-9]|[ｧ-ﾝﾞﾟ]|[0-9\@\.\_\-])*$/i) && isEmpty;
                fieldValidationErrors.emailClient = emailValid ? '' : 'is invalid';
                break;
            case 'passwordClient':
                isEmpty = !value ? false : true
                passwordValid2 = value.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/i) && isEmpty;
                fieldValidationErrors.passwordClient = passwordValid2 ? '' : 'is invalid';
                break;
            default:
                break;
        }
        this.setState({
            formErrors2: fieldValidationErrors,
            passwordValid2: passwordValid2,
            emailValid: emailValid
        }, this.validateForm2);
    }

    validateForm2() {
        this.setState({ formValid2: this.state.passwordValid2 && this.state.emailValid });
    }


    UNSAFE_componentWillMount() {
        this.setState({ showLoading: true });
        this.props.getAllCompanyAdmin();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        var values = queryString.parse(this.props.location.search);
        let search;
        if (values.keyword) {
            search = `?keyword=${values.keyword}&page=${values.page}`
        } else {
            search = `?page=${values.page}`
        }
        if (nextProps) {
            if (nextProps.status === ACTIONS.GET_DATA_COMPANY_SUCCESS && nextProps.data) {
                this.setState({
                    objAllCompanies: nextProps.data,
                    showLoading: false
                });
            } else if ((nextProps.status === ACTIONS.POST_DATA_COMPANY_SUCCESS && nextProps.data)
                || nextProps.status === ACTIONS.POST_DATA_COMPANY_ERROR
            ) {
                if (!nextProps.message) {
                    this.setState({
                        message: nextProps.message,
                        showPopup: true ,
                        isReciveProps: true,
                        showLoading: false,
                    }, () => {
                        this.hideModalAddCompany();
                        this.props.getAllCompanyAdmin();
                    });
                } else {
                    this.setState({
                        message: nextProps.message,
                        isReciveProps: true,
                        showLoading: false,
                    }, () => {
                        this.hideModalAddCompany();
                    });
                }
            } else if ((nextProps.status === ACTIONS.UPDATE_DATA_COMPANY_SUCCESS && nextProps.data)
                || nextProps.status === ACTIONS.UPDATE_DATA_COMPANY_ERROR
            ) {
                if (!nextProps.message) {
                    this.setState({
                        showLoading: false,
                        showModalEdit: false
                    }, () => {
                        this.props.getAllCompanyAdmin();
                    });
                } else {
                    this.setState({
                        showModalEdit: false,
                        message: nextProps.message,
                        isReciveProps: true,
                        showLoading: false,
                    }, () => {
                        this.props.getAllCompanyAdmin();
                    });
                }
            } else if ((nextProps.status === ACTIONS.REMOVE_DATA_COMPANY_SUCCESS && nextProps.message)) {
                this.setState({
                    showModalDelete: false,
                    message: nextProps.message,
                    showPopup: true,
                    isReciveProps: true,
                    showLoading: false,

                }, () => {
                    nextProps.message !== 'IDは存在しません' && this.props.getAllCompanyAdmin();
                })
                nextProps.message !== 'IDは存在しません' && this.props.getAllCompanyAdmin()
            } else if (nextProps.status === ACTIONS.GET_DATA_CLIENT_SUCCESS && nextProps.data) {
                const data = convertAdminClient(nextProps.data.data)
                this.setState({
                    allClientAdmin: data,
                    showLoading: false,
                    meta: nextProps.meta
                })
            } else if ((nextProps.status === ACTIONS.ADD_DATA_CLIENT_SUCCESS && nextProps.data)
                || nextProps.status === ACTIONS.ADD_DATA_CLIENT_ERROR
            ) {
                this.props.getAdminClient(search);
                this.setState({
                    message: nextProps.message,
                    nameClient: '',
                    emailClient: '',
                    passwordClient: '',
                    isReciveProps: true,
                    showLoading: false,
                })
            } else if ((nextProps.status === ACTIONS.DELETE_DATA_CLIENT_SUCCESS && nextProps.message)) {
                this.setState({
                    showPopup: true,
                    isReciveProps: true,
                    showLoading: false,
                }, () => {
                    this.props.getAdminClient(search);
                });
            } else if ((nextProps.status === ACTIONS.UPDATE_DATA_CLIENT_SUCCESS && nextProps.data)
                || nextProps.status === ACTIONS.UPDATE_DATA_CLIENT_ERROR
            ) {
                this.setState({
                    showPopup: true,
                    message: nextProps.message,
                    isReciveProps: true,
                    showLoading: false,
                });
                this.props.getAdminClient(search);
            }

        }
    }

    offDropdown = (e, i, key) => {
        const selectDropdown = e.target.parentNode;
        selectDropdown.style.display = 'none';
        if (i === 0) {
            this.setState({
                showModalEdit: true,
                idCompany: key.id,
                name: key.name,
                code: key.code,
                showPopup: false,
            });
        } else {
            this.setState({
                showModalDelete: true,
                idCompany: key.id,
                showPopup: false,
            })
        }
    };

    updateInfoCompany = () => {
        this.setState({ showLoading: true });
        let dataUpdate = {
            name: this.state.name,
            code: this.state.code,
            id: this.state.idCompany
        }
        this.props.updateCp(dataUpdate);
    }

    deleteCompany = () => {
        this.setState({ showLoading: true });
        this.props.removeCompany(this.state.idCompany)
    }

    closeModalMessage = () => {
        this.setState({
            showPopup: false
        })
    }

    ridrectToListUsers = (id, name) => {
        this.props.history.push(`/admin-list-user/groups/${id}/${name}`);
    };

    showPage = () => {
        if (this.state.isAdminClient) {
            return (
                <div className="admin-individual">
                    <div className="individual-content">
                        <div>
                            <Table
                                actionItemDropdownDot={(e, k, items) => this.showDeleteUser(e, k, items)}
                                showCheckbox={false}
                                showPaginationTop={true}
                                meta={this.state.meta}
                                header={this.props.header}
                                itemOfPage={this.state.allClientAdmin}
                                onChangePage={this.onChangePage}
                            />
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div className="wrap-items-company">
                    <div className="admin--company-content  flex-wrap ">
                        {
                            this.state.objAllCompanies.map((value, index) => {
                                return (
                                    <div className="items-company " key={index}>
                                        <h4 className="name-company" onClick={() => this.ridrectToListUsers(value.id, value.name)}>{value.name}</h4>
                                        <p className="code-company">{value.code}</p>
                                        <div className=" justify-content-between">
                                            <label className="quantity-user">{value.users_count} 人のユーザー</label>
                                            <div className=" dropdown-dot" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                <img src="./img/ic_dot_vertical.svg" alt="dot" className=" multi-dot" />
                                                <div className="dropdown-menu dropdown-menu-right" >
                                                    <button onClick={(e) => this.offDropdown(e, 0, value)}
                                                        className="dropdown-item" type="button">編集</button>
                                                    <button onClick={(e) => this.offDropdown(e, 1, value)}
                                                        className="dropdown-item" type="button">削除</button>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            )
        }
    }

    onChangePage = (page, check) => {
        this.setState({
            showLoading: true,
        })
        const values = queryString.parse(this.props.location.search);
        let search;
        if (values.keyword) {
            search = `?keyword=${values.keyword}&page=${page}`
        } else {
            search = `?page=${page}`
        }
        // this.props.history.push({
        //     pathname: '/admin-company',
        //     search: search
        // })
        this.props.getAdminClient(search);
    }

    showDeleteUser = (e, k, items) => {
        if (k === 0) {
            this.setState({
                showSettingClient: true,
                nameClientSetting: items[0].text,
                emailClientSetting: items[1].text,
                idClient: items[0].id,
                showPopup: false,
            })
        } else {
            this.setState({
                showDeleteClient: true,
                idClient: items[0].id,
                email: items[1].text,
                showPopup: false,
            })
        }
    }

    hideCompanySetting = () => {
        this.setState({ showSettingClient: false });
    }

    hideAddIndividual = () => {
        this.setState({ isShowClient: false });
    }

    componentDidMount = () => {

        window.addEventListener('click', (e) => {
            const allMultiDot = document.getElementsByClassName('multi-dot');
            for (let i = 0; i < allMultiDot.length; i++) {
                if (e.target === allMultiDot[i]) {
                    allMultiDot[i].nextSibling.style.display = 'block';
                } else {
                    allMultiDot[i].nextSibling.style.display = 'none';
                }
            }
        });

    }

    commonHideComponent = (e, c) => {
        const isClickChild = e.target.classList.contains(c);
        if (isClickChild) {
            this.setState({
                showModalDelete: false,
                showModalAdd: false,
                showModalEdit: false,
                showSettingClient: false,
                isShowClient: false
            })
        }
    }

    changePageToClient = (e) => {
        e.target.parentNode.firstChild.style.backgroundColor = '#F2F5F7';
        e.target.parentNode.firstChild.style.color = '#6E7F8A';
        e.target.parentNode.firstChild.style.border = '1px solid #D1D9DE';
        e.target.parentNode.lastChild.style.backgroundColor = '#3D3DF2';
        e.target.parentNode.lastChild.style.color = 'white';
        e.target.parentNode.lastChild.style.border = '1px solid #3D3DF2';
        this.setState({
            isAdminClient: true,
            showLoading: true,
        });

        this.onChangePage(1, true);
    }

    changePageToCompany = (e) => {
        e.target.parentNode.firstChild.style.backgroundColor = '#3D3DF2';
        e.target.parentNode.firstChild.style.color = 'white';
        e.target.parentNode.firstChild.style.border = '1px solid #3D3DF2';
        e.target.parentNode.lastChild.style.backgroundColor = '#F2F5F7';
        e.target.parentNode.lastChild.style.color = '#6E7F8A';
        e.target.parentNode.lastChild.style.border = '1px solid #D1D9DE';
        this.setState({
            isAdminClient: false,
        });
    }

    addData = () => {

        if (this.state.isAdminClient) {
            this.setState({
                isShowClient: true,
                showPopup: false,
                message: '',
            })
        } else {
            this.setState({
                message: '',
                showPopup: false,
            })

            this.showAddCompany();
            return null
        }
    }

    showAddCompany = () => {
        this.setState({ showModalAdd: true });
    }

    hideModalAddCompany = () => {
        this.setState({ showModalAdd: false, name: '', code: '' });
    }

    closeDeleteClient = () => {
        this.setState({ showDeleteClient: false })
    }

    handleAddCompany = (ev) => {
        ev.preventDefault();
        this.setState({ showLoading: true });
        let data = {
            name: this.state.name,
            code: this.state.code
        };
        this.props.addCompany(data)
    }

    handleChange = (inputName, value) => {
        this.setState({ [inputName]: value }, () => {
            this.validateCode(inputName, value);
        });
    }

    onSearchCompany = (e) => {
        if (e.key === 'Enter') {
            this.setState({
                showLoading: true
            })

            if (this.state.isAdminClient) {
                this.props.searchClient(e.target.value)
            } else {
                this.props.searchCompany(e.target.value);
            }
        }
    }

    changeClientAdmin = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        this.setState({
            [name]: value
        }, () => {
            this.validateField2(name, value)
        });
    }

    sendAddClientAdmin = () => {
        const { nameClient, emailClient, passwordClient } = this.state;
        const body = {
            name: nameClient,
            email: emailClient,
            password: passwordClient
        }
        this.setState({
            isShowClient: false,
            showLoading: true
        })
        this.props.addClientAdmin(body);

    }

    returnActionDelete = (id) => {
        this.setState({ showLoading: true });
        this.props.deleteClientAdmin(id);
    }

    changeSettingClient = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({
            [name]: value
        }, () => {
            this.validateField(name, value);
        })
    }

    actionEditClient = () => {
        const { nameClientSetting, passClientSetting, emailClientSetting } = this.state;
        const body = {
            name: nameClientSetting,
            password: passClientSetting,
            email: emailClientSetting
        }
        this.props.updateClientAdmin(body, this.state.idClient);
        this.setState({
            showLoading: true,
            showSettingClient: false,
            passClientSetting: ''
        })

    }

    render() {
        return (
            <Fragment>
                <div className="admin--company" >
                    <div className="admin--company-title  justify-content-between align-items-center">
                        <h3>顧客</h3>
                        <div className="title-middle">
                            <button style={{width: 88}} onClick={(e) => this.changePageToCompany(e)}>企業</button>
                            <button style={{width: 88}} onClick={(e) => this.changePageToClient(e)}>個人</button>
                        </div>
                        <div className="title-end ">
                            <div className="search-company position-relative  align-items-center">
                                <input type="text" placeholder="検索" onKeyDown={(e) => this.onSearchCompany(e)} />
                                <img alt="search" src="/img/ic_search_svg.svg" className="position-absolute" />
                            </div>
                            {
                                this.state.isAdminClient
                                    ? <Button addData={() => this.addData()} title="新規作成" showIcon={true} />
                                    : <Button addData={() => this.addData()} title="新規作成" showIcon={true} />
                            }
                        </div>
                    </div>
                    {this.showPage()}
                </div>

                <div className="wrap-user-delete" id="wrap-user-delete" onClick={(e) => this.commonHideComponent(e, 'wrap-user-delete')}>
                    <div className="user-delete" id="user-delete">
                        <h4>ユーザーの削除</h4>
                        <p>このユーザーを削除します。本当によろしいですか？</p>
                        <div>
                            <div>
                                <label>ログインID : </label>
                                <span>loginid</span>
                            </div>
                            <div>
                                <label>所属企業 : </label>
                                <span>企業名</span>
                            </div>
                            <div>
                                <label>所属グループ : </label>
                                <span>グループ名</span>
                            </div>
                        </div>
                        <div>
                            <button onClick={() => this.hideDeleteUser()}>キャンセル</button>
                            <button>削除</button>
                        </div>
                    </div>
                </div>

                {
                    this.state.showModalDelete ?
                        <div className="wrap-company-delete" onClick={(e) => this.commonHideComponent(e, 'wrap-company-delete')}>
                            <div className="company-delete">
                                <h4>企業を削除</h4>
                                <p>この企業を削除します。</p>
                                <p>よろしいですか？</p>
                                <div>
                                    <button onClick={() => this.setState({ showModalDelete: false })}>キャンセル</button>
                                    <button onClick={this.deleteCompany}>削除</button>
                                </div>
                            </div>
                        </div> : null
                }

                {/* add client admin */}
                {
                    this.state.isShowClient
                        ? <div className="wrap-individual-add" id="wrap-individual-add" onClick={(e) => this.commonHideComponent(e, 'wrap-individual-add')}>
                            <div className="individual-add" id="individual-add">
                                <h4>個人利用者追加</h4>
                                <div>
                                    <div>
                                        <label>ログインID</label>
                                        <input type="text" placeholder="ログインIDを入力してください" value={this.state.emailClient} name="emailClient" onChange={(e) => this.changeClientAdmin(e)} />
                                    </div>
                                    <div>
                                        <label>名前</label>
                                        <input type="text" placeholder="名前を入力してください" value={this.state.nameClient} name="nameClient" onChange={(e) => this.changeClientAdmin(e)} />
                                    </div>
                                    <div>
                                        <label>パスワード</label>
                                        <input type="password" placeholder="パスワードを入力してください" value={this.state.passwordClient} name="passwordClient" autocomplete="new-password" onChange={(e) => this.changeClientAdmin(e)} />
                                    </div>
                                </div>
                                <div>
                                    <button onClick={() => this.hideAddIndividual()}>キャンセル</button>
                                    <button
                                        type='reset'
                                        onClick={() => this.sendAddClientAdmin()}
                                        disabled={!this.state.formValid2}
                                        >追加</button>
                                </div>
                            </div>
                        </div>
                        : null

                }

                {/* add company */}
                {
                    this.state.showModalAdd ?
                        <div className="modal-add-company" onClick={(e) => this.commonHideComponent(e, 'modal-add-company')}>
                            <form className="add-company" ref="formAdd">
                                <h4>企業追加</h4>
                                <div>
                                    <label>企業名</label>
                                    <input type='text' placeholder="企業名を入力してください"
                                        value={this.state.name}
                                        onChange={(event) => this.handleChange('name', event.target.value)} />
                                </div>
                                <div>
                                    <label>企業コード</label>
                                    <input type='text' placeholder="企業コードを入力してください"
                                        value={this.state.code}
                                        onChange={(event) => this.handleChange('code', event.target.value)} />
                                </div>
                                <div className="group-btn-add">
                                    <button onClick={() => this.hideModalAddCompany()}>キャンセル</button>
                                    <button
                                        disabled={this.state.name === '' || !this.state.codeValid}
                                        onClick={this.handleAddCompany}>追加
                                        </button>
                                </div>
                            </form>
                        </div> : null
                }

                {/* edit company */}
                {
                    this.state.showModalEdit ?
                        <div className="modal-edit-company" onClick={(e) => this.commonHideComponent(e, 'modal-edit-company')}>
                            <div className="edit-company" id="edit-company">
                                <h4>編集</h4>
                                <div>
                                    <label>企業名</label>
                                    <input type='text' placeholder="企業名を入力してください"
                                        value={this.state.name}
                                        onChange={(event) => this.handleChange('name', event.target.value)} />
                                </div>
                                <div>
                                    <label>企業コード</label>
                                    <input type='text' placeholder="企業コードを入力してください"
                                        value={this.state.code}
                                        onChange={(event) => this.handleChange('code', event.target.value)} />
                                </div>
                                <div className="group-btn-add">
                                    <button
                                        onClick={() => this.setState({ showModalEdit: false, name: '', code: '' })}>キャンセル</button>
                                    <button disabled={this.state.name === '' || !this.state.codeValid}
                                        onClick={this.updateInfoCompany}>変更</button>
                                </div>
                            </div>
                        </div> : null
                }

                {/* delete client admin */}
                {
                    this.state.showDeleteClient
                        ? <AdminUserDelete
                            returnActionDelete={(id) => this.returnActionDelete(id)}
                            id={this.state.idClient}
                            onClose={() => this.closeDeleteClient()}
                            email={this.state.email}
                        />
                        : null
                }


                {/* admin client edit */}
                {
                    this.state.showSettingClient
                        ? <div className="wrap-company-setting" id="wrap-company-setting" onClick={(e) => this.commonHideComponent(e, 'wrap-company-setting')}>
                            <div className="company-setting" id="company-setting">
                                <h4>編集</h4>
                                <div>
                                    <label>名前</label>
                                    <div>
                                        <input
                                            type='text'
                                            // name="emailClientSetting"
                                            // onChange={(e) => this.changeSettingClient(e)}
                                            // value={this.state.nameClientSetting}
                                            type='text'
                                            name="nameClientSetting"
                                            onChange={(e) => this.changeSettingClient(e)}
                                            value={this.state.nameClientSetting}
                                            placeholder="名前を入力してください"
                                        />
                                    </div>
                                </div>
                                <div>
                                    <label>パスワード</label>
                                    <div>
                                        <input
                                            type="password"
                                            name="passClientSetting"
                                            placeholder="パスワードを入力してください"
                                            autocomplete="new-password"
                                            onChange={(e) => this.changeSettingClient(e)}
                                            value={this.state.passClientSetting}
                                        />
                                    </div>
                                </div>
                                <div>
                                    <label>備考</label>
                                    <div>
                                        <textarea
                                            name=""
                                            onChange={(e) => this.changeSettingClient(e)}
                                            value={''}
                                        ></textarea>
                                    </div>
                                </div>


                                <div>
                                    <button onClick={() => this.hideCompanySetting()}>キャンセル</button>
                                    <button
                                        disabled={!this.state.formValid}
                                        onClick={() => this.actionEditClient()}
                                    >変更</button>
                                </div>
                            </div>
                        </div>
                        : null
                }


                <Loading show={this.state.showLoading} />

            </Fragment>
        )
    }
}


const mapStateToProps = ({ adminCompany }) => {
    return {
        table: adminCompany.table,
        status: adminCompany.status,
        data: adminCompany.response,
        header: adminCompany.header,
        message: adminCompany.message,
        meta: adminCompany.meta,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getAllCompanyAdmin: () => {
            dispatch(getAllCompanyAdmin());
        },
        addCompany: (data) => {
            dispatch(addCompany(data));
        },
        updateCp: (data) => {
            dispatch(updateCompany(data));
        },
        removeCompany: (data) => {
            dispatch(removeCompany(data));
        },
        searchCompany: (data) => {
            dispatch(searchCompany(data));
        },
        getAdminClient: (query) => {
            dispatch(getAdminClient(query));
        },
        addClientAdmin: (data) => {
            dispatch(addClientAdmin(data));
        },
        deleteClientAdmin: (id) => {
            dispatch(deleteClientAdmin(id));
        },
        updateClientAdmin: (data, id) => {
            dispatch(updateClientAdmin(data, id));
        },
        searchClient: (text) => {
            dispatch(searchClient(text));
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(AdminCompany);
